<!-- Modal -->

<div class="modal-header border-0">
    <h3 class="modal-title" id="changePasswordLabel">Cambiar contraseña</h3>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate errorTailor>
    <div class="modal-body">
        <!-- Contraseña actual -->
        <div class="mb-3">
            <label for="currentPassword" class="form-label">Contraseña actual</label>
            <input
                    id="currentPassword"
                    type="password"
                    class="form-control"
                    formControlName="currentPassword"
            />
            <div class="invalid-feedback">La contraseña actual es obligatoria.</div>
        </div>

        <!-- Nueva contraseña -->
        <div class="mb-3">
            <label for="newPassword" class="form-label">Nueva contraseña</label>
            <input
                    id="newPassword"
                    type="password"
                    class="form-control"
                    formControlName="newPassword"
            />
        </div>
        <app-password-strength-bar
                [password]="form.controls.newPassword.value??''"></app-password-strength-bar>
        <!-- Confirmar contraseña -->
        <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirmar contraseña</label>
            <input
                    id="confirmPassword"
                    type="password"
                    class="form-control"
                    formControlName="confirmPassword"
            />
            @if (form.errors?.['mismatch']) {
                <p class="invalid-feedback" style="display: block !important;">Las contraseñas no coinciden</p>
            }
        </div>
    </div>

    <div class="modal-footer border-0">
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">
            Cancelar
        </button>
        <button [disabled]="submitted()" type="submit" class="btn btn-primary">
            Guardar cambios
        </button>
    </div>
</form>
